"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcDataAutocompleteFieldChip = void 0;
var react_1 = __importDefault(require("react"));
var AcDataAutocompleteFieldChip = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, onClearChip = _a.onClearChip;
    return (react_1.default.createElement("div", { id: "field", title: title + "\n" + subtitle, className: "d-flex rounded-sm border p-1 bg-white", style: {
        // width: '230px',  //for testing in storybook
        } },
        react_1.default.createElement("span", { id: "chip", className: "d-flex align-items-center bg-apzlightblue rounded-lg pl-3 pr-2 py-1 mw-100", style: {
                border: '1px solid #edf1f5',
                height: '31px',
                cursor: 'default',
            } },
            title && (react_1.default.createElement("span", { className: "text-truncate text-dark mr-2 fs-14", style: {} }, title)),
            subtitle && (react_1.default.createElement("span", { className: "mr-2 fs-11 flex-shrink-0", style: {} }, subtitle)),
            react_1.default.createElement("i", { onClick: onClearChip, className: "far fa-times text-secondary fa-fw fs-18", style: {
                    cursor: 'pointer',
                } }))));
};
exports.AcDataAutocompleteFieldChip = AcDataAutocompleteFieldChip;
exports.AcDataAutocompleteFieldChip.displayName = 'AcDataAutocompleteFieldChip';
//# sourceMappingURL=AcDataAutocompleteFieldChip.js.map